const isObject = (obj) => obj === Object(obj);

export default isObject;